import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ee796dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "queue-option__info" }
const _hoisted_2 = { class: "queue-option__header" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "queue-option__path" }
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "queue-option__path-separator" }, ">", -1))
const _hoisted_7 = ["title"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "queue-option__path-separator" }, ">", -1))
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "queue-option__parent-task-button-content" }
const _hoisted_11 = {
  key: 0,
  class: "queue-option__parent-task-avatar-text"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "queue-option__parent-task-id" }

import { computed, PropType } from 'vue';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmIconView,
  TirPmSvg,
} from 'tir-components';
import { QueueRelationModel } from '../../models';
import { ConnectIcon, FolderIcon } from 'tir-style-system/icons/outline';
import { ListBulletIcon } from 'tir-style-system/icons/solid';
import { TirPmTooltipElement } from 'tir-pm-tooltip-element';
import { RouteLocationRaw, RouterLink, useRouter } from 'vue-router';

/**Роутер */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-queue-search-dropdown-option',
  props: {
  /**Очередь */
  queue: {
    type: Object as PropType<QueueRelationModel>,
    required: true,
  },
  /**Текущая очередь */
  isCurrentQueue: {
    type: Boolean,
    default: false,
  },
},
  emits: ["select"],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();





/**Автор родительской задачи */
const parentTaskAuthor = computed(() => props.queue.ParentTask?.Author);
/**Текст для аватарки автора родительской задачи очереди */
const parentTaskAuthorAvatarText = computed(() => {
  const first = parentTaskAuthor.value?.FirstName?.[0]?.toLocaleUpperCase() ?? '';
  const last = parentTaskAuthor.value?.LastName?.[0]?.toLocaleUpperCase() ?? '';
  return first + last;
});
/**Текст для тултипа автора родительской задачи очереди */
const parentTaskAuthorTooltipText = computed(() => {
  if (!parentTaskAuthor.value) return;

  return `${parentTaskAuthor.value.LastName} ${parentTaskAuthor.value.FirstName} ${parentTaskAuthor.value.MiddleName}`;
});

const parentTaskRoute = computed<RouteLocationRaw | undefined>(() => {
  if (props.queue.ParentTask?.Access)
    return {
      name: 'task-detail',
      params: {
        taskId: props.queue.ParentTask.TaskId,
        queueId: props.queue.ParentTask.QueueId,
        namespaceId: props.queue.ParentTask.NamespaceId,
        projectId: props.queue.ParentTask.ProjectId,
      },
    };
});

/**Обработчик события `click` */
const onClick = () => {
  if (props.queue.ParentTask || props.isCurrentQueue) return;
  emit('select');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'task-queue-search-dropdown-option',
      { 'with-parent': !!__props.queue.ParentTask || __props.isCurrentQueue },
    ]),
    onClick: onClick
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(ListBulletIcon), { class: "queue-option__queue-icon" }),
        _createElementVNode("span", {
          class: "queue-option__queue-name",
          title: __props.queue.Name
        }, _toDisplayString(__props.queue.Name), 9, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "queue-option__path-section",
          style: _normalizeStyle({ flexShrink: __props.queue.Namespace.Name.length })
        }, [
          _createVNode(_unref(TirPmSvg), {
            url: __props.queue.Namespace.Icon,
            class: "queue-option__path-section-namespace-icon",
            color: __props.queue.Namespace.Color
          }, null, 8, ["url", "color"]),
          _createElementVNode("span", {
            class: "queue-option__path-section-text",
            title: __props.queue.Namespace.Name
          }, _toDisplayString(__props.queue.Namespace.Name), 9, _hoisted_5),
          _hoisted_6
        ], 4),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.queue.Groups, (group) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "queue-option__path-section",
            style: _normalizeStyle({ flexShrink: group.Name.length }),
            key: group.Id
          }, [
            _createVNode(_unref(FolderIcon), { class: "queue-option__path-section-icon" }),
            _createElementVNode("span", {
              class: "queue-option__path-section-text",
              title: group.Name
            }, _toDisplayString(group.Name), 9, _hoisted_7),
            _hoisted_8
          ], 4))
        }), 128)),
        _createElementVNode("div", {
          class: "queue-option__path-section",
          style: _normalizeStyle({ flexShrink: __props.queue.Name.length })
        }, [
          _createVNode(_unref(ListBulletIcon), { class: "queue-option__path-section-icon" }),
          _createElementVNode("span", {
            class: "queue-option__path-section-text",
            title: __props.queue.Name
          }, _toDisplayString(__props.queue.Name), 9, _hoisted_9)
        ], 4)
      ])
    ]),
    (__props.queue.ParentTask)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(parentTaskRoute.value ? _unref(RouterLink) : 'span'), {
          key: 0,
          to: parentTaskRoute.value
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TirPmButton), {
              class: "queue-option__parent-task-button",
              variant: _unref(TirPmButtonVariantEnum).SecondaryState,
              size: _unref(TirPmButtonSizeEnum).Small,
              "is-disabled": !__props.queue.ParentTask.Access,
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_unref(TirPmTooltipElement), { class: "queue-option__tooltip-element" }, {
                    content: _withCtx(() => [
                      (parentTaskAuthorTooltipText.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(parentTaskAuthorTooltipText.value), 1))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      (parentTaskAuthor.value && !__props.isCurrentQueue)
                        ? (_openBlock(), _createBlock(_unref(TirPmIconView), {
                            key: 0,
                            class: "queue-option__parent-task-author",
                            size: 24,
                            "is-rounded": true,
                            "is-bordered": false,
                            "image-load-url": parentTaskAuthor.value.ImageUrl,
                            "color-code": parentTaskAuthor.value.AvatarColor
                          }, {
                            mainSlot: _withCtx(() => [
                              (parentTaskAuthorAvatarText.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(parentTaskAuthorAvatarText.value), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["image-load-url", "color-code"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(__props.queue.ParentTask.TaskId), 1),
                  _createVNode(_unref(ConnectIcon), { class: "queue-option__parent-task-icon" })
                ])
              ]),
              _: 1
            }, 8, ["variant", "size", "is-disabled"])
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})